import React from 'react';
import TextField from '@mui/material/TextField';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { StyledButton, StyledButtonBox } from '../index.styles';
import { mapError } from 'src/utils/validation';
import {
  FormErrors,
  RegistrationReoSchema,
  validateForm,
  validateFormFirstPage,
} from '../form';
import Consents from '../components/Consents';
import ScheduleMeetingDialog from '../components/ScheduleMeetingDialog';
import { useLanguage, useSupportedCountries } from 'src/common/hooks';

export default function RegistrationFirstPage(props: {
  form: RegistrationReoSchema;
  setForm: React.Dispatch<React.SetStateAction<RegistrationReoSchema>>;
  errors: FormErrors;
  setErrors: React.Dispatch<React.SetStateAction<FormErrors>>;
  onNext: () => void;
}) {
  const { form, setForm, errors, setErrors, onNext } = props;
  const { t, language } = useLanguage();

  const [scheduleMeetingDialogOpen, setScheduleMeetingDialogOpen] =
    React.useState<boolean>(false);

  const isError = (fieldName: keyof RegistrationReoSchema) =>
    !!form[fieldName] && !!mapError(errors, fieldName, form[fieldName]);
  const errorText = (fieldName: keyof RegistrationReoSchema) =>
    !!form[fieldName] &&
    String(t(mapError(errors, fieldName, form[fieldName]) || ''));

  const handleNextPageButtonClick = () => {
    if (form.consent_reo_analytics && form.consent_marketing) {
      onNext();
    } else {
      setScheduleMeetingDialogOpen(true);
    }
  };

  return (
    <>
      {[
        'organization_name',
        'vat_identifier',
        'first_name',
        'last_name',
        'email',
        'phone_number',
        'city',
      ].map((field) => (
        <TextField
          key={field}
          sx={{ mt: '24px' }}
          label={t(`registration_bnp:reo.form.${field}`)}
          type="text"
          value={form[field as keyof RegistrationReoSchema]}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const newForm = {
              ...form,
              [field]: e.currentTarget.value,
            };
            setForm(newForm);
            setErrors(validateForm(newForm));
          }}
          variant="outlined"
          fullWidth
          required
          error={isError(field as keyof RegistrationReoSchema)}
          helperText={errorText(field as keyof RegistrationReoSchema)}
        />
      ))}

      <Consents form={form} setForm={setForm} />

      <StyledButtonBox sx={{ justifyContent: 'right' }}>
        <StyledButton
          variant="contained"
          size="large"
          onClick={handleNextPageButtonClick}
          disabled={Object.keys(validateFormFirstPage(form)).length > 0}
          endIcon={<NavigateNextIcon fontSize="large" />}
        >
          {t('registration_bnp:nextPage')}
        </StyledButton>

        <ScheduleMeetingDialog
          open={scheduleMeetingDialogOpen}
          onClose={() => setScheduleMeetingDialogOpen(false)}
        />
      </StyledButtonBox>
    </>
  );
}
